// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedContactInformationPurposeType } from './siteV3ClientGeneratedContactInformationPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedEmailAddressUpsearchModel {
    'emailAddressId'?: number | null;
    'emailAddressType'?: SiteV3ClientGeneratedContactInformationPurposeType;
    'address': string;
    'language': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedEmailAddressUpsearchModel>> = [
        {
            "name":     "emailAddressId",
            "baseName": "emailAddressId",
            "type":     "number"
        },
        {
            "name":     "emailAddressType",
            "baseName": "emailAddressType",
            "type":     "SiteV3ClientGeneratedContactInformationPurposeType"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
